export class HeroCard {
	container;
	cardContainer;
	cardElement;
	iconsShadowElement;
	iconsMainElement;

	orbList;

	rotation = [-30, -45, 15];
	rotationTimeout = null;
	mobileScrollDebounceDuration = 50;
	mobileScrollTimeout = null;

	constructor(imageContainer) {
		this.container = document.createElement("hero-card");
		this.cardContainer = document.createElement("div");
		this.cardContainer.classList.add("card-container");
		this.cardElement = imageContainer.querySelector("img");
		this.iconsShadowElement = new Image();
		this.iconsShadowElement.src = "/asset/image/hero/icons.svg";
		this.iconsShadowElement.classList.add("icons", "icons-main");

		this.iconsMainElement = new Image();
		this.iconsMainElement.src = "/asset/image/hero/icons.svg";
		this.iconsMainElement.classList.add("icons", "icons-shadow");

		this.iconsShadowElement.alt = this.iconsMainElement.alt = "";

		this.cardElement.classList.add("card");
		this.cardContainer.appendChild(this.cardElement);

		this.orbList = [];
		for(let i = 0; i < 10; i++) {
			let orb = document.createElement("div");
			orb.classList.add("orb");
			this.orbRandom(orb);
			let size = 1 + (Math.random() * 3);
			orb.style.setProperty("--size-orb", `${size}rem`);
			setTimeout(() => {this.orbRandom(orb, true)}, 100);
			this.orbList.push(orb);
		}

		let swoosh = document.createElement("div");
		swoosh.classList.add("swoosh");
		let swoosh2 = swoosh.cloneNode();
		swoosh.classList.add("swoosh-1");
		swoosh2.classList.add("swoosh-2");

		imageContainer.classList.add("hero-card-enabled");
		imageContainer.append(this.container);
		this.container.append(...this.orbList, this.iconsShadowElement, this.iconsMainElement, swoosh, swoosh2, this.cardContainer);

		this.rotationAnimation();
		if(navigator.maxTouchPoints) {
			window.addEventListener("scroll", this.mobileScroll.bind(this));
		}
		else {
			document.body.addEventListener("mousemove", this.mouseMove.bind(this));
		}
	}

	orbRandom(orb, skipAutoCall) {
		let orbit = orb.style.getPropertyValue("--orbit");
		if(!orbit) {
			orbit = Math.random() * 360;
		}
		orbit = parseFloat(orbit);
		orbit += Math.random() * 45;
		if(orbit < 0) {
			orbit += 360;
		}
		if(orbit > 360) {
			orbit -= 360;
		}
		orb.style.setProperty("--orbit", orbit.toString());

		let distanceMultiplier = (Math.random() / 4) + 0.75;

		let orbitRad = orbit * Math.PI / 180;
		let x = Math.cos(orbitRad) * 50 * distanceMultiplier;
		let y = Math.sin(orbitRad) * 25 * distanceMultiplier;

		orb.style.setProperty("--orbit-x", `${x}%`);
		orb.style.setProperty("--orbit-y", `${y}%`);

		if(!skipAutoCall) {
			setTimeout(() => {
				this.orbRandom(orb)
			}, 20000);
		}
	};

	rotationAnimation() {
		this.cardContainer.style.transition = "transform 10s ease-in-out";

		this.rotation[1] = -((Math.random() * 5) + 42.5);
		this.rotation[2] = (Math.random() * 20);
		if(!this.cardContainer.dataset.rotationAnimation) {
			this.cardContainer.dataset.rotationAnimation = Math.random().toString();
			setTimeout(() => { this.rotationAnimation(); }, 100);
		}

		this.cardContainer.style.transform = `translateZ(0) rotateX(${this.rotation[0]}deg) rotateY(${this.rotation[1]}deg) rotateX(${this.rotation[2]}deg)`;
		this.rotationTimeout = setTimeout(() => {this.rotationAnimation()}, 11000);
	}

	mouseMove(e) {
		let maxY = document.querySelector("section.hero").offsetHeight;

		let x = (e.clientX / (window.innerWidth / 2)) * 0.25;
		let y = (e.clientY / maxY) - 0.5;

		let xRot = this.rotation[1] + (x * 20);
		let yRot = this.rotation[2] + (y * 10);

		if(this.rotationTimeout) {
			clearTimeout(this.rotationTimeout);
			this.rotationTimeout = null;
		}

		if(this.mouseDelayTimeout) {
			clearTimeout(this.mouseDelayTimeout);
			this.mouseDelayTimeout = null;
		}

		this.mouseDelayTimeout = setTimeout(() => {
				this.cardContainer.style.transition = "transform 1s ease-in-out";
				this.rotationAnimation();
			},
			1000
		);

		this.cardContainer.style.transition = "transform 1s ease-out";
		this.cardContainer.style.transform = `translateZ(0) rotateX(${this.rotation[0]}deg) rotateY(${xRot}deg) rotateX(${yRot}deg)`;
	}

	mobileScroll(e) {
		if(this.mobileScrollTimeout) {
			return;
		}

		this.mobileScrollTimeout = setTimeout(() => {
			this.mobileScrollDebounced(e);
			this.mobileScrollTimeout = null;
		}, this.mobileScrollDebounceDuration);
	}

	mobileScrollDebounced(e) {
		if(window.scrollY > window.innerHeight) {
			return;
		}

		let maxY = document.querySelector("section.hero").offsetHeight;
		let y = (window.scrollY / maxY * 4);
		let yRot = this.rotation[1] + (Math.min(y, 2) * 10);
		this.cardContainer.style.transition = "transform 1s ease-out";
		this.cardContainer.style.transform = `translateZ(0) rotateX(${this.rotation[0]}deg) rotateY(${yRot}deg) rotateX(${this.rotation[2]}deg)`;

		if(this.mouseDelayTimeout) {
			clearTimeout(this.mouseDelayTimeout);
			this.mouseDelayTimeout = null;
		}

		this.mouseDelayTimeout = setTimeout(() => {
				this.cardContainer.style.transition = "transform 1s ease-in-out";
				this.rotationAnimation();
			},
			1000
		);
	}
}
